import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { IconButton, Paper } from "@mui/material";
import { observer } from "mobx-react";
import * as React from "react";

interface IDrawerToggleOverlayProps {
  isMenuOpen: boolean;
  onOpenMenu: () => void;
  isMenuEnabled: boolean;
}

const DrawerToggleOverlay: React.FC<IDrawerToggleOverlayProps> = observer(
  ({ isMenuOpen, onOpenMenu, isMenuEnabled }) => {
    if (isMenuOpen || !isMenuEnabled) {
      return null;
    }

    return (
      <Paper
        elevation={0}
        onMouseEnter={onOpenMenu}
        sx={{
          position: "fixed",
          left: 0,
          top: 6,
          zIndex: 1200,
          borderRadius: "0 4px 4px 0",
          overflow: "hidden",
          backgroundColor: "transparent",
          cursor: "pointer",
        }}
      >
        <IconButton
          color="primary"
          aria-label="open drawer"
          size="small"
          sx={{
            borderRadius: 0,
            padding: "16px 4px",
            pointerEvents: "none",
          }}
        >
          <ChevronRightIcon fontSize="small" />
        </IconButton>
      </Paper>
    );
  }
);

export default DrawerToggleOverlay;
